<template>
    <div class="card">
        <div class="flex justify-between items-center">
            <div class="flex justify-between items-center">
                <div class="bg-neutral-lightest py-sm px-md rounded-full">
                    <font-awesome-icon icon="sliders-h" />
                </div>
                <span class="font-semibold mx-lg">
                    Visar filtrerade resultat:
                </span>
            </div>
            <button
                type="button"
                class="btn is-ghost is-primary btn-sm"
                @click="resetFilters"
            >
                Rensa alla
            </button>
        </div>
        <div class="flex mt-lg">
            <div
                v-for="filter in filledFilters"
                :key="`filter_${filter.label}`"
                class="bg-neutral-lightest rounded p-sm mr-md text-xs"
            >
                <span class="font-semibold">
                    {{ filter.label }}:
                </span>
                <br>
                <span>
                    {{ filter.value }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            managerOptions: {
                type: Object,
                required: true,
            },
            companyOptions: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                filterOptions: [
                    {
                        label: 'Projektledare',
                        value: this.getManager(),
                    },
                    {
                        label: 'Entreprenör grävning',
                        value: this.getCompany('dig_phase_company_id'),
                    },
                    {
                        label: 'Entreprenör installation',
                        value: this.getCompany('installation_phase_company_id'),
                    },
                    {
                        label: 'Entreprenör driftsättning',
                        value: this.getCompany('activation_phase_company_id'),
                    },
                ],
                status: null,
            };
        },
        computed: {
            filledFilters() {
                return this.filterOptions.filter((filterOption) => filterOption.value);
            },
        },
        mounted() {
            this.status = get_request_value('status');
        },
        methods: {
            resetFilters() {
                window.location = route('admin.delivery-projects.index', { status: this.status });
            },
            getManager() {
                if (get_request_value('manager_id') === '0') {
                    return 'Ej tilldelade';
                }

                return this.findRequestItem('manager_id', this.managerOptions);
            },
            getCompany(companyKey) {
                return this.findRequestItem(companyKey, this.companyOptions);
            },
            findRequestItem(requestKey, options) {
                const itemId = get_request_value(requestKey);
                if (itemId) {
                    for (const [name, id] of Object.entries(options)) {
                        if (id === parseInt(itemId)) {
                            return name;
                        }
                    }
                }

                return null;
            },
        },
    };
</script>
